import { useEffect, useState } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

export function useBufferedContent(
	streamedTextToDisplay: string,
	isStreamComplete: boolean = false,
): string {
	const [bufferedContent, setBufferedContent] = useState('');

	useEffect(() => {
		// When streamed text is cleared reset buffered content
		if (!streamedTextToDisplay && bufferedContent && fg('kd_fix_abort_errors')) {
			setBufferedContent('');
			return;
		}
		// Split by newlines to handle various line endings
		const lines = streamedTextToDisplay.split(/\r?\n|\r/);

		// If stream is complete, include all content including the last line
		if (isStreamComplete) {
			const allContent = lines.join('\n');
			if (allContent !== bufferedContent) {
				const delay = bufferedContent === '' ? 0 : 250;
				setTimeout(() => {
					setBufferedContent(allContent);
				}, delay);
			}
			return;
		}

		// Only update if we have more than one line (complete sections)
		if (lines.length > 1) {
			// Take everything except the last line (incomplete section)
			const completeSections = lines.slice(0, -1).join('\n');

			// Only update if the complete sections are different from what we already have
			if (completeSections !== bufferedContent) {
				// First section appears immediately, subsequent sections have delay
				const delay = bufferedContent === '' ? 0 : 250;
				setTimeout(() => {
					setBufferedContent(completeSections);
				}, delay);
			}
		}
	}, [streamedTextToDisplay, bufferedContent, isStreamComplete]);

	return bufferedContent;
}
